module.exports = __webpack_public_path__ + "media/images/badge/nostradamus_secondary-d7e788c88f3a2d3e9c832d90d8fbec72.png";